import {
  PROJECTS_CRUD_SET_INFORMATION,
  PROJECTS_CRUD_SET_CURRENT_PROJECT,
  PROJECT_SET_STATUS,
  ATTEMPT_TO_SAVE_CURRENT_PROJECT
} from "../lib/types";

export const setProjectInfo = data => dispatch => {
  dispatch({
    type: PROJECTS_CRUD_SET_INFORMATION,
    payload: data
  });
};

export const setCurrentProject = project => dispatch => {
  dispatch({
    type: PROJECTS_CRUD_SET_CURRENT_PROJECT,
    payload: project
  });
};

export const setProjectStatus = status => dispatch => {
  dispatch({
    type: PROJECT_SET_STATUS,
    payload: {
      ...status
    }
  });
};

export const runSaveProjectAction = runSaveProject => dispatch => {
  dispatch({
    type: ATTEMPT_TO_SAVE_CURRENT_PROJECT,
    payload: runSaveProject
  });
}



// WEBPACK FOOTER //
// ./src/actions/project-actions.js